import PeriPackShotTube from '../../../assets/periGum/signal-poster.jpg';
import DownloadIcon from '../../../assets/periGum/download-Icon.png'
import React, { useState, useEffect } from 'react'
import { postLogDetails } from "../../../Services/APIs/appDetails";
import { downloadPdf } from '../../../Services/APIs/report'

const LastPage = () => {
  const language = localStorage.getItem("userLanguage") || "en";

  // Get UID
  const storedUid = localStorage.getItem("usertpi");
  const initialId = storedUid ? JSON.parse(storedUid).usertpi : '';

  const uid = JSON.parse(localStorage.getItem("usertpi") || "{}").usertpi
  const initialDownloadText = language === "vn" ? "Tải về báo cáo chi tiết" :
    language === "bs" ? "Laporan lengkap\n disini" :
      language === "ab" ? "تحميل التقرير الكامل هنا" :
        "Download full report\n here"; // Default to English

  const [downloadText, setDownloadStatus] = useState(initialDownloadText);

  // Check if font is loaded
  useEffect(() => {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        console.log('Fonts loaded');
      });
    }
  }, []);

  const download = async () => {
    setDownloadStatus(language === "vn" ? "Đang tải xuống..." :
      language === "bs" ? "mengunduh..." :
        language === "ab" ? "جاري التحميل..." :
          "Downloading...");
    const file = localStorage.getItem("pdf");
    if (file) {
      const company = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket;
      await downloadPdf({ file, company, uid })
        .then((response) => {
          const url = response.data?.data?.info;
          const link = document.createElement("a");
          link.href = url;
          link.download = file; // Optional: Specify a download attribute
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setDownloadStatus(language === "vn" ? "Tải xuống thành công" :
            language === "bs" ? "Berhasil diunduh" :
              language === "ab" ? "تم التحميل بنجاح" :
                "Download Successful");

          setTimeout(() => {
            setDownloadStatus(initialDownloadText);
          }, 2500);
        })
        .catch((error) => {
          setDownloadStatus(language === "vn" ? "Thất bại, thử lại..." :
            language === "bs" ? "Gagal, coba lagi..." :
              "Failed, try again...");
          setTimeout(() => {
            setDownloadStatus(initialDownloadText);
          }, 2500);
        });
    } else {
      setDownloadStatus(language === "vn" ? "Có gì đó sai.\n Vui lòng thử lại sau" :
        language === "bs" ? "Ada yang salah.\n Silakan coba lagi nanti" :
          "Something went wrong.\n Please try again later");
    }
  };
  
  postLogDetails({
    uid: initialId,
    app: `pericheck-${language}`,
    payLoad: `In result page`
  });

  // Define font style to match GumHealthSummary
  const fontStyle = {
    fontFamily: "'Cera Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontWeight: 500
  };

  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center bg-white overflow-hidden p-4" style={fontStyle}>
      {/* Main content container with fixed height */}
      <div className="flex flex-col items-center justify-center w-full h-full max-h-screen">
        {/* Image container with responsive sizing */}
        <div className="flex-1 flex items-center justify-center w-full min-h-0">
          <img
            src={PeriPackShotTube}
            alt="Packshot"
            className="max-h-full max-w-full object-contain"
            style={{ 
              maxHeight: '60vh', // Limit image to 60% of viewport height
              width: 'auto',
              height: 'auto'
            }}
          />
        </div>
        
        {/* Download section with fixed height */}
        <div className='text-center pb-8 pt-4'>
          <button 
            type="button" 
            className='hover:opacity-80 transition-opacity' 
            onClick={download}
          >
            <img 
              className='inline-block h-12 w-12 sm:h-16 sm:w-16' 
              src={DownloadIcon} 
              alt='download icon' 
            />
          </button>
          <p 
            className="mt-2  text-sm text-peri-blue font-cera-pro-medium font-bold" 
          
          >
            {downloadText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LastPage;